import RestAPI from "@aws-amplify/api-rest";
import { validateEmail50, validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import { dateFormat, utcToDate } from "../../../utils/date";

export class Arable {
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const selectedDevice = props.dialogState.data.devices.find(d => d.id === values.arableDeviceId);
                const body = {
                    ...values,
                    from: utcToDate(values.from.toISOString(), props.timezone, true).format(),
                    sectorName: selectedDevice.site,
                    nodeName: selectedDevice.displayName,
                    locale: i18n.language,
                    tipo: "ARABLE"
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: t("external.username"),
                            campo: "username",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            component: "text",
                            eyeForPassword: true,
                            type: "password",
                        },
                    ],
                },
                {
                    label: t("sass.conectar"),
                    inputs: [
                        {
                            label: t("thead.device"),
                            campo: "arableDeviceId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "devices",
                            optionLabel: "site",
                            optionKey: "id"
                        },
                        {
                            label: t("node.ultimoDato"),
                            campo: "from",
                            validation: validateSomething,
                            component: "date",
                            minDate: sixMonthsAgo,
                            maxDate
                        },
                        {
                            component: "info",
                            triggeredBy: "arableDeviceId",
                            optionsKey: "id",
                            optionsName: "devices",
                            content: (value, selected) => {
                                return (<>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className='boldie'>{t("external.statusConnection")}</label>
                                    </div>
                                    <div className="col-12 col-md-6 text-md-left d-block">
                                        <label className="">{t(`external.status.${selected?.state}`)}</label>
                                    </div>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className='boldie'>{t("external.connection")}</label>

                                    </div>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className="">{selected.lastSyncDate === "" || selected.lastSyncDate === null ? null : dateFormat(selected.lastSyncDate, t, i18n.language, null, false, true)}</label>
                                    </div>
                                </>);
                            }
                        },
                        { campo: "arableApiKey" },
                        { campo: "email" },
                    ],
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const erUser = validateEmail50(values.username);
                if (erUser !== undefined) errors.username = erUser;

                const erPass = validateSomething(values.password);
                if (erPass !== undefined) errors.password = erPass;

                if(errors.password || errors.username) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);
                    const endpoint = `/external/${props.farmId}/arable-credentials`;
                    const body = {
                        "arableEmail": values.username,
                        "arablePassword": values.password
                    };
                    const data = await RestAPI.post("apiAdminDropControl", endpoint, { body });

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            devices: data?.devices,
                            arableApiKey: data?.apiKey,
                            email: values.username,
                        }
                    }));
                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            toast.error(props.t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            if (error.response?.data?.badCredentials){
                errors.unknown = props.t("forms.toast401");
            } else {
                errors.unknown = props.t("external.error-sign-in");
            }
            props.setForceLoading(false);
            return errors;
        }
    }
}

